import React from 'react';
import SvgIcon from './SvgIcon';

const ArrowTaleDown = props => (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M12 18.75V5.25M17.25 13.5L12 18.75 6.75 13.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

ArrowTaleDown.displayName = 'ArrowTaleDownIcon';

export default ArrowTaleDown;
